module.exports = __webpack_public_path__ + "static/media/emirates-card-dark.2d5b45fe.svg";